(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(23486);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_authentication_guest_guard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33149);
/* harmony import */ var _hooks_use_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89731);
/* harmony import */ var _lib_gtm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38682);
/* harmony import */ var _authentication_login_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4175);







var Login = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var platform = (0,_hooks_use_auth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .a)().platform;
    var disableGuard = router.query.disableGuard;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        _lib_gtm__WEBPACK_IMPORTED_MODULE_5__/* .gtm.push */ .w.push({
            event: "page_view"
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_authentication_login_html__WEBPACK_IMPORTED_MODULE_6__["default"], {});
});
Login.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_authentication_guest_guard__WEBPACK_IMPORTED_MODULE_3__/* .GuestGuard */ .A, {
        children: page
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Login);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6447,5294,6135,135,5377,1664,3911,9272,5381,5907,4175,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);